import YAxisPanel from './y-axis-panel'
import nonAxesPlotType from 'scoreboard/charts/non-axes-plot-type'
import { chart as isPolarChart } from 'scoreboard/charts/is-polar'
import isRtl from 'scoreboard/components/is-rtl'

const LeftAxisPanel = YAxisPanel.extend({
	className: YAxisPanel.prototype.className + ' left-axis-panel',

	/**
	 * @override
	 */
	axis: 'left',

	/**
	 * @override
	 */
	_getTitle: function() {
		if (nonAxesPlotType(this.model) || isPolarChart(this.model)) {
			return 'charts.chart.yAxis.data'
		} else {
			// Though we're setting the API's left axis, it will visually render
			// on the right in RTL mode, so the title needs to reflect that.
			let renderedAxis = isRtl() ? 'right' : 'left'
			return `charts.chart.${renderedAxis}Axis`
		}
	}
})

export default LeftAxisPanel

LeftAxisPanel.__filename__ = 'charts/edit/left-axis-panel.js'
